import ClientForm from "./ClientForm";
import { getLocationDetails } from "./LocationHelper";
import Modal from "./Modal";

const ContactFormModal = () => {
    const modalInstance = Modal('js-contact-modal');

    if (!modalInstance) {
        console.log('modal not found');
        return;
    }
    const fetchForm = async (lt: string, id: string) => {
        try {
            const response = await fetch(`/contact-us/modal?lt=${lt}&id=${id}`); // Replace with the actual API endpoint
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.text(); // Assuming the response is HTML
            // Replace the contents of the target div
            const contentDiv = document.getElementById('js-contact-modal-form');
            if (contentDiv) {
                contentDiv.innerHTML = data; // Inject the new HTML content

                const zipCodeInput = document.getElementById('contact-zip_code') as HTMLInputElement | null;
                if (zipCodeInput) {
                    // Set a character limit
                    const characterLimit = 5; // Example limit for US zip codes

                    // Attach the 'input' event listener
                    zipCodeInput.addEventListener('input', () => {
                        const zipCodeValue = zipCodeInput.value.trim();

                        // Check if the value meets the character limit
                        if (zipCodeValue.length >= characterLimit) {
                            getLocationDetails();
                        }
                    });

                    // Also attach 'focusout' event in case of manual entry
                    zipCodeInput.addEventListener('focusout', () => {
                        const zipCodeValue = zipCodeInput.value.trim();

                        // Check if the value meets the character limit
                        if (zipCodeValue.length >= characterLimit) {
                            getLocationDetails();
                        }
                    });
                }

                const form = document.querySelector<HTMLFormElement>('#js-form-contact');

                if (form) {
                    const clientForm = ClientForm();
                    form.addEventListener('submit', clientForm.handleSubmit);
                }                
            }
        } catch (error) {
            console.error('Failed to fetch content:', error);
        }
    };

    const open = (lt: string, id: string) => {
        modalInstance.open();
        fetchForm(lt, id);
    };

    return {
        open
    }
};

export default ContactFormModal;
